<div class="table-responsive">
  <table class="table table-narrow w-100">
    <thead>
      <tr>
        <th style="width: 50px"></th>
        <th style="width: 50px">{{ ('Order_Table.Section' | trans) }}</th>
        <th style="width: 40px">{{ ('Order_Table.Row' | trans) }}</th>
        <th style="width: 40px">{{ ('Order_Table.Seat' | trans) }}</th>
        <th>{{ ('Order_Table.Access_Group' | trans) }}</th>
        <th>{{ ('Order_Table.Type' | trans) }}</th>
        <th style="width: 110px">{{ ('Order_Table.Price' | trans) }}</th>
        <th style="width: 110px">{{ ('Order_Table.Actions' | trans) }}</th>
      </tr>
    </thead>
    <tbody>
      @if (order) {
        @for (orderItemGroup of order.groupedOrderItems; track orderItemGroup) {
          <tr>
            <td colspan="4">
              <div>
                <strong>{{ orderItemGroup.name }}</strong>
              </div>
              @if (orderItemGroup) {
                <div>{{ orderItemGroup.event?.startAt | date:'mediumDate' }}</div>
              }
            </td>
            <td colspan="1">
              <div class="form-group">
                <div class="form-input">
                  <select class="form-control"
                    [disabled]="!editable"
                    (change)="updateOrderVenueSectionAccess($event.target.value, orderItemGroup.items)"
                    data-component="cm-select">
                    <option disabled>{{ ('Order_Table.Access_Group' | trans) }}</option>
                    <option value="">{{ ('Order_Table.No_Access_Group' | trans) }}</option>
                    @if (getVenue(orderItemGroup.venueId); as venue;) {
                      @for (section of venue.sections; track section) {
                        <option disabled>{{ section.name }}</option>
                        @for (venueSection of section.sections; track venueSection) {
                          <option
                            [value]="venueSection.id">
                            {{ venueSection.name }}
                          </option>
                        }
                      }
                    }
                    @for (venueSection of venueSections; track venueSection) {
                      <option [value]="venueSection.id">
                        {{ venueSection.name }}
                      </option>
                    }
                  </select>
                  <label></label>
                </div>
              </div>
            </td>
            <td>
              @if (orderItemGroup.type === 'TICKET') {
                <div class="form-group">
                  <div class="form-input">
                    <select class="form-control" data-component="cm-select" [disabled]="!editable"
                      (change)="updateOrderTicketType($event.target.value, orderItemGroup.items)">
                      <option [value]="null">{{ ('General.Ticket_Type' | trans) }}</option>
                      @for (ticketType of orderItemGroup.types; track ticketType) {
                        <option [value]="ticketType.id">
                          {{ ticketType.name }}
                        </option>
                      }
                    </select>
                    <label></label>
                  </div>
                </div>
              }
              @if (orderItemGroup.type === 'SUBSCRIPTION') {
                <div class="form-group">
                  <div class="form-input">
                    <select class="form-control" data-component="cm-select" [disabled]="!editable"
                      (change)="updateOrderSubscriptionTypePrice($event.target.value, orderItemGroup.items)">
                      <option [value]="null">{{ ('Order_Table.Price_Type' | trans) }}</option>
                      @for (subscriptionType of orderItemGroup.types; track subscriptionType) {
                        <option [value]="subscriptionType.id">
                          {{ subscriptionType.name }}
                        </option>
                      }
                    </select>
                    <label></label>
                  </div>
                </div>
              }
              @if (orderItemGroup.type === 'PRODUCT') {
                <div class="form-group">
                  <div class="form-input">
                    <select class="form-control" data-component="cm-select" [disabled]="!editable"
                      (change)="updateOrderProductTypePrice($event.target.value, orderItemGroup.items)">
                      <option [value]="null">{{ ('Order_Table.Price_Type' | trans) }}</option>
                      @for (productTypePrice of orderItemGroup.types; track productTypePrice) {
                        <option [value]="productTypePrice.id">
                          {{ productTypePrice.name }}
                        </option>
                      }
                    </select>
                    <label></label>
                  </div>
                </div>
              }
            </td>
            <td>
              <div class="form-group">
                <div class="form-input">
                  <input placeholder="{{('Order_Table.Price' | trans)}}"
                    [disabled]="!editable"
                    (change)="updateOrderPrice($event.target.value, orderItemGroup.items)"
                    class="form-control">
                  <label></label>
                </div>
              </div>
            </td>
            <td>
            </td>
          </tr>
          @for (orderItem of orderItemGroup.items; track orderItem; let i = $index) {
            @if (i >= ((currentPage - 1) * itemsPerPage) && i < (currentPage * itemsPerPage)) {
              <tr [class.loading]="orderItem._loading"
                [class.b-b-none]="orderItem.note || displayOrderNote === orderItem.id">
                @if (orderItem.ticket) {
                  <td [cm-tooltip]="orderItem.ticket.status">
                    @if (orderItem.ticket.status === 'CANCELED') {
                      <span
                      class="cm-icon cm-icon-error cl-error-color" aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'BLOCKED') {
                      <span
                      class="cm-icon cm-icon-block cl-error-color" aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'RESERVED') {
                      <span
                        class="cm-icon cm-icon-time-fill cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'ISSUED') {
                      <span
                        class="cm-icon cm-icon-verification cl-success-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'REFUNDED') {
                      <span
                      class="cm-icon cm-icon-refund cl-black-50" aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'RESELL_AVAILABLE') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'RESELL_RESERVED') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.ticket.status === 'RESELL_SOLD') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-success-color"
                      aria-hidden="true"></span>
                    }
                  </td>
                  <td class="reset-line-height">
                    <span class="parent-venue-section">
                    {{ orderItem.ticket.seat.parentSectionName }}</span><br>
                    {{ orderItem.ticket.seat.sectionName }}
                  </td>
                  <td>{{ orderItem.ticket.seat.row }}</td>
                  <td>{{ orderItem.ticket.seat.seat }}</td>
                  <td>
                    <div class="form-group">
                      <div class="form-input">
                        <select class="form-control f-w-200"
                          [disabled]="!editable"
                          [(ngModel)]="orderItem.ticket.venueSectionAccessIds[0]"
                          (change)="updateOrderItemVenueSectionAccess($event.target.value, orderItem)"
                          data-component="cm-select">
                          <option value="">{{ ('Order_Table.No_Access_Group' | trans) }}
                          </option>
                          @if (getVenue(orderItem.ticket.venueId); as venue;) {
                            @for (section of venue.sections; track section) {
                              <option disabled>{{ section.name }}</option>
                              @for (venueSection of section.sections; track venueSection) {
                                <option
                                  [value]="venueSection.id">{{ venueSection.name }}
                                </option>
                              }
                            }
                          }
                          @for (venueSection of venueSections; track venueSection) {
                            <option
                              [value]="venueSection.id">{{ venueSection.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </td>
                  <td class="reset-line-height">
                    <div class="form-group">
                      <div class="form-input">
                        <select class="form-control f-w-200"
                          data-component="cm-select"
                          [(ngModel)]="orderItem.ticket.ticketTypeId"
                          [disabled]="!editable"
                          (change)="updateOrderItemType($event.target.value, orderItem, orderItemGroup.id)">
                          @for (ticketType of orderItemGroup.types; track ticketType) {
                            <option [value]="ticketType.id"
                              [disabled]="!getTicketTypePrice(ticketType, orderItem.ticket)">
                              {{ ticketType.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </td>
                }
                @if (orderItem.subscription) {
                  <td [cm-tooltip]="orderItem.subscription.status">
                    @if (orderItem.subscription.status === 'CANCELED') {
                      <span
                      class="cm-icon cm-icon-error cl-error-color" aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'BLOCKED') {
                      <span
                      class="cm-icon cm-icon-block cl-error-color" aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'RESERVED') {
                      <span
                        class="cm-icon cm-icon-time-fill cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'ISSUED') {
                      <span
                        class="cm-icon cm-icon-verification cl-success-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'REFUNDED') {
                      <span
                      class="cm-icon cm-icon-refund cl-black-50" aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'RESELL_AVAILABLE') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'RESELL_RESERVED') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.subscription.status === 'RESELL_SOLD') {
                      <span
                        class="cm-icon cm-icon-duplicate cl-success-color"
                      aria-hidden="true"></span>
                    }
                  </td>
                  <td class="reset-line-height">
                    <div class="parent-venue-section">
                      @if (orderItem.subscription.seat) {
                        {{ orderItem.subscription.seat.parentSectionName }}
                      }
                    </div>
                    @if (orderItem.subscription.seat) {
                      {{ orderItem.subscription.seat.sectionName }}
                    }
                  </td>
                  <td>
                    @if (orderItem.subscription.seat) {
                      {{ orderItem.subscription.seat.row }}
                    }
                  </td>
                  <td>
                    @if (orderItem.subscription.seat) {
                      {{ orderItem.subscription.seat.seat }}
                    }
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="form-input">
                        <select class="form-control f-w-200" [disabled]="!editable"
                          [(ngModel)]="orderItem.subscription.venueSectionAccessIds[0]"
                          (change)="updateOrderItemVenueSectionAccess($event.target.value, orderItem)"
                          data-component="cm-select">
                          <option value="">{{ ('Order_Table.No_Access_Group' | trans) }}
                          </option>
                          @if (getVenue(orderItemGroup.venueId); as venue;) {
                            @for (section of venue.sections; track section) {
                              <option disabled>{{ section.name }}</option>
                              @for (venueSection of section.sections; track venueSection) {
                                <option
                                  [value]="venueSection.id">
                                  {{ venueSection.name }}
                                </option>
                              }
                            }
                          }
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="form-input">
                        <select class="form-control f-w-200"
                          data-component="cm-select"
                          [(ngModel)]="orderItem.subscription.subscriptionTypePriceId"
                          [disabled]="!editable"
                          (change)="updateOrderItemSubscriptionTypePrice(orderItem, orderItem.subscription.subscriptionTypePriceId)">
                          @for (subscriptionTypePrice of orderItemGroup.types; track subscriptionTypePrice) {
                            <option [ngValue]="subscriptionTypePrice.id">
                              {{ subscriptionTypePrice.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </td>
                }
                @if (orderItem.product) {
                  <td [cm-tooltip]="orderItem.product.status">
                    @if (orderItem.product.status === 'CANCELED') {
                      <span
                      class="cm-icon cm-icon-error cl-error-color" aria-hidden="true"></span>
                    }
                    @if (orderItem.product.status === 'RESERVED') {
                      <span
                        class="cm-icon cm-icon-time-fill cl-warning-color"
                      aria-hidden="true"></span>
                    }
                    @if (orderItem.product.status === 'ISSUED') {
                      <span
                        class="cm-icon cm-icon-verification cl-success-color"
                      aria-hidden="true"></span>
                    }
                  </td>
                  <td colspan="3">{{ orderItem.product.name }}</td>
                  <td>
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="form-input">
                        <select class="form-control f-w-200"
                          data-component="cm-select"
                          [(ngModel)]="orderItem.product.productTypePriceId"
                          [disabled]="!editable"
                          (change)="updateOrderItemType($event.target.value, orderItem, orderItemGroup.id)">
                          @for (productTypePrice of orderItemGroup.types; track productTypePrice) {
                            <option [value]="productTypePrice.id">
                              {{ productTypePrice.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </td>
                }
                <td>
                  <div class="form-group">
                    <div class="form-input">
                      <input placeholder="{{('Order_Table.Price' | trans)}}"
                        class="form-control f-w-200"
                        [disabled]="!editable"
                        (change)="updateOrderItemPrice(orderItem)"
                        [(ngModel)]="orderItem.price">
                    </div>
                  </div>
                  @for (costItemAgreement of orderItem.additionalCosts; track costItemAgreement) {
                    @if (costItemAgreement.amount > 0) {
                      <div class="order-item-cost-item-agreement">
                        {{ costItemAgreement.label }}
                        : {{ costItemAgreement.amount | currency:costItemAgreement.currencyId }}
                      </div>
                    }
                  }
                </td>
                <td class="text-right">
                  <div style="position: relative; top: 3px;">
                    @if (!orderItem._loading) {
                      @if (editable) {
                        <button class="btn btn-secondary-icon m-r-16"
                          (click)="openOrderItemNote(orderItem.id)">
                          <span class="cm-icon cm-icon-edit " aria-hidden="true"></span>
                        </button>
                      }
                      @if (editable) {
                        <button class="btn btn-secondary-icon"
                          (click)="deleteOrderItem(orderItem)">
                          <span class="cm-icon cm-icon-delete" aria-hidden="true"></span>
                        </button>
                      }
                    } @else {
                      <cm-indicator class="small"></cm-indicator>
                    }
                    @if (orderItem.ticket?.status === 'ISSUED' || orderItem.subscription?.status === 'ISSUED' ||
                      orderItem.product?.status === 'ISSUED') {
                      <cm-button
                        data-icon="block"
                        data-button-style="secondary"
                        data-button-type="icon"
                        data-button-size="small"
                        (click)="cancelOrderItem(orderItem)"
                        [cm-tooltip]="('Order_Table.Cancel_Order_Item' | trans)">
                      </cm-button>
                    }
                  </div>
                </td>
              </tr>
              @if (orderItem.note || displayOrderNote === orderItem.id) {
                <tr>
                  <td colspan="4"></td>
                  <td colspan="4">
                    <div class="form-group">
                      <div class="form-input">
                        <input [disabled]="!editable" type="text" name="orderItemNote"
                          id="orderItemNote" class="form-control"
                          (change)="updateOrderItemNote(orderItem.note, orderItem)"
                          [(ngModel)]="orderItem.note">
                        <label for="orderItemNote">{{ ('Order_Table.Ticket_Note' | trans) }}</label>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          }
        }
        @for (additionalCost of order.additionalCosts; track additionalCost) {
          <tr>
            <td></td>
            <td class="text-right" colspan="5">{{ additionalCost.label }}</td>
            <td class="text-right">
              {{ additionalCost.amount | currency }}
            </td>
            <td class="text-right"></td>
          </tr>
        }
        @for (discount of order.discounts; track discount) {
          <tr class="discount-table-row">
            <td colspan="5"></td>
            <td class="text-right">{{ discount.name }}</td>
            <td class="text-right cl-success-color f-w-700">
              -{{ discount.amount | currency }}
            </td>
            <td class="text-right">
              @if (editable) {
                <button class="btn btn-secondary-icon"
                  (click)="deleteOrderDiscount(discount.id)">
                  <span class="cm-icon cm-icon-delete" aria-hidden="true"></span>
                </button>
              }
            </td>
          </tr>
        }
        <tr>
          <td colspan="5"></td>
          <td class="text-right">
            @if (order.totalDiscountAmount > 0) {
              {{ ('Order_Table.Price_After_Discount' | trans) }}
            }
            @if (order.totalDiscountAmount === 0) {
              {{ ('Order_Table.Price' | trans) }}
            }
          </td>
          <td class="text-right">
            <strong>
              {{ order.getPrice()| currency }}
            </strong>
          </td>
          <td class="text-right">
            @if (editable) {
              <button
                class="btn btn-secondary-icon"
                (click)="openDiscountDialog()"
                [cm-tooltip]="('Order_Table.Add_Discount' | trans)">
                <span class="cm-icon cm-icon-tag" aria-hidden="true"></span>
              </button>
            }
          </td>
        </tr>
      } @else {
        <cm-indicator></cm-indicator>
      }
    </tbody>
  </table>
</div>


